import { ReactComponent as AcademicRecognitionLogo } from "@duosoftbg/nacid-components/dist/assets/images/icon-Diploma.svg";
import { ReactComponent as ProfQualificationLogo } from "@duosoftbg/nacid-components/dist/assets/images/icon-Prof-Qual.svg";

const registersList = [
  {
    href: "/academic-recognitions",
    icon: <AcademicRecognitionLogo />,
    title: "t.page.academicRecognition",
    description: "m.academicRecognition.desc",
  },
  {
    href: "/professional-qualifications",
    icon: <ProfQualificationLogo />,
    title: "t.page.professionalQualifications",
    description: "m.professionalQualifications.desc",
  },
];

const navItems = [
  {
    title: "t.eRegisters",
    pages: registersList,
  },
];

export { registersList };
export default navItems;
